
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PlanCard from './PlanCard';
import { toast } from 'sonner';

import { planData } from '@/constants/planData';


export default function PlansComparison() {
  const navigate = useNavigate();
  
  // Função para lidar com a seleção de plano
  const handleSelectPlan = (plan: string) => {
    toast.success(`Plano ${plan} selecionado!`);
    // Redirecionando para a página de registro do cliente antes da configuração do plano
    navigate('/registro-cliente', { state: { selectedPlan: plan } });
  };

  return (
    <section id="planos" className="py-20 md:py-28 bg-white">
      <div className="container px-4 mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <span className="inline-block text-brand-roxo font-semibold text-sm uppercase tracking-wider mb-3">
            Planos
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-extrabold text-brand-azul mb-4 leading-tight">
            Escolha o ritmo da sua operação
          </h2>
          <p className="text-lg text-brand-azul/70 leading-relaxed">
            Todos os planos incluem a I.A. de negociação no WhatsApp. Troque de plano quando o volume pedir.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4">
          {[
            /* Plano Basic oculto por solicitação (mantido comentado para referência futura)
            {
              key: 'Basic',
              description: 'Ideal para pequenas empresas iniciando automação de negociações',
            },
            */
            {
              key: 'Advanced',
              description: 'Para empresas que buscam volumes de negociações para reduzir preços rapidamente',
              popular: false,
            },
            {
              key: 'Pro',
              description: 'Para empresas com diversas pessoas envolvidas em compras e alto volume de negociações',
              popular: true,
            },
            {
              key: 'Premium',
              description: 'Solução robusta para empresas que buscam automação plena dos processos de negociações de compras',
              popular: false,
            },
            {
              key: 'PremiumPlus',
              description: 'Para grandes empresas que precisam de customização e atendimento exclusivo',
              popular: false,
            },
          ].map(({ key, description, popular }) => {
            const plan = planData[key];
            if (!plan) return null; // Verificação defensiva
            return (
              <PlanCard
                key={key}
                name={plan.name}
                price={plan.basePrice}
                period="mês"
                description={description}
                features={plan.features}
                popular={!!popular}
                whatsappIncluded={plan.whatsappIncluded}
                whatsappPrice={plan.whatsappPrice}
                users={plan.users}
                negotiationsIncluded={plan.negotiationsIncluded}
                extraNegotiationsPrice={plan.extraNegotiationsPrice}
                setupFee={plan.setupFee}
                onSelect={handleSelectPlan}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}

